'use client';

import { c as _c } from "react/compiler-runtime";
import { readPreference, readPreferenceFallback, subscribeToPreferences, type PreferenceKey, type PreferenceValue } from '@/lib/preferences';
import { useCallback, useSyncExternalStore } from 'react';

/**
 * Renders a stored preference and re-renders when it changes, including from another tab.
 * The server, and the first render on the client, see the fallback, so hydration matches.
 * Write it with `writePreference`.
 */
export function usePreference(key) {
  const $ = _c(4);
  let t0;
  if ($[0] !== key) {
    t0 = () => readPreference(key);
    $[0] = key;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getSnapshot = t0;
  let t1;
  if ($[2] !== key) {
    t1 = () => readPreferenceFallback(key);
    $[2] = key;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getServerSnapshot = t1;
  return useSyncExternalStore(subscribeToPreferences, getSnapshot, getServerSnapshot);
}